import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step2(props: IQuestionnaireFormProps) {
    const questions: IHsdqQuestion[] = [
        {
            key: 'restlessLegs',
            label: 'Als ik “rusteloze benen” heb, kan ik dit gevoel onderdrukken door te lopen of mijn benen te strekken',
            number: 6,
        },
        {
            key: 'poorSleep',
            label: 'De kwaliteit van mijn slaap is slecht en ik voel me ’s morgens dan ook niet uitgerust',
            number: 7,
        },
        {
            key: 'urgeToMoveLegs',
            label: 'Als ik rustig zit, vooral ’s avonds, voel ik de drang om mijn benen te bewegen',
            number: 8,
        },
        {
            key: 'moveLegs',
            label: 'Tijdens mijn slaap lig ik met mijn benen of armen te bewegen',
            number: 9,
        },
        {
            key: 'lieAwake',
            label: 'Ik lig ’s nachts lang wakker',
            number: 10,
        },
    ];

    return (
        <>
            <PageIntro title="HSDQ: vragen deel 2/7" />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
